import type {
  FormattedUser,
  SortUserColumn,
  UpdateUserRequest
} from '@library/types/user';

export const DEFAULT_USER_SORT: SortUserColumn = {
  sortBy: 'email',
  sortDirection: 'asc'
};
export const DEACTIVATE_USER = 'Deactivate user';
export const DEACTIVATE_USER_LABEL = 'Confirm Deactivation';
export const DEACTIVATE_USER_CONTENT =
  'Are you sure you want to deactivate this user?';
export const DEACTIVATE_USER_ACTION: UpdateUserRequest = {
  admin_user: {
    deactivated: true
  }
};
export const DEFAULT_USER_DATA: FormattedUser = {
  id: '',
  type: 'admin_user',
  email: '',
  first_name: '',
  last_name: '',
  google_avatar: '',
  sign_in_count: 0,
  current_sign_in_at: null,
  last_sign_in_at: null,
  current_sign_in_ip: null,
  last_sign_in_ip: null,
  created_at: '',
  updated_at: '',
  deactivated: false,
  permissions: [],
  roles: []
};
